import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/project';

import Button from '@material-ui/core/Button';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Modal from '@material-ui/core/Modal';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import {Cards} from '../components';
import {Cards2} from '../components';


const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    button: {
        'margin-top': '15px',
        float: 'right'
    },
    fab: {
        'margin-top': '15px',
        float: 'right',
        background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)'
    },
    card: {
        maxWidth: 205,
    },

}));



function ProjectDetail({match: {params: {projectId}}, selected, deleteProject, patchProject, getProject, wait}) {
    const [open, setOpen] = React.useState(false);
    const classes = useStyles();

    React.useEffect(
        () => {
            getProject(projectId);
        },
        [projectId]
    );

    React.useEffect(
        () => {
            selected && setValues({...values, title: selected.title});
        },
        [selected]
    );

    const [values, setValues] = React.useState({
        title: '',
    });

    const handleClickDelete = event => {
      deleteProject(projectId);
    };

    const handleChange = name => event => {
        setValues({...values, [name]: event.target.value});
    };

    const handleClickPatch = event => {
        patchProject(projectId, values.title);
        setOpen(false);
    };


    if (wait) {
        return <div>Waiting...</div>
    }

    if (!selected) {
        return <div>Not found</div>
    }

    return (
        <>
        <div className={classes.root}>
          <Grid container spacing={3}>
             <Grid item xs={12} sm={6}>
               <h1>Project Apps | {selected.title}</h1>
             </Grid>
             <Grid item xs={12} sm={6}>
             </Grid>
         </Grid>
        </div>
        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            className={classes.modal}
            open={open}
            onClose={() => setOpen(false)}
        >

            <div className={classes.paper}>
              <h2 id="simple-modal-title">Изменить проект</h2>

                <div>
                  <form
                    className={classes.root}
                    noValidate autoComplete="off"
                  >
                    <TextField
                      id="title"
                      label="Name"
                      value={values.title}
                      onChange={handleChange('title')} />
                    <Button
                      variant="contained"
                      color="primary"
                      style={{
                        background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7'}}
                      onClick={handleClickPatch}>
                        Изменить
                    </Button>
                  </form>
                </div>
                <div>
                  <IconButton
                    className={classes.button}
                    color="secondary"
                    onClick={() => handleClickDelete()}
                    aria-label="delete">
                    <DeleteIcon />
                  </IconButton>
                </div>
              </div>
        </Modal>

        <h2>Blue Ocean</h2>
        <Grid container spacing={7}>
          <Grid item xs={8} sm={6} md={4} lg={2}>
            <Cards
              link={`/project/${projectId}/strategymap`}
              title={'As-Is Strategy Canvas'}
              text='Industry parameters and levels of competition'
              imgPath={`${process.env.PUBLIC_URL}/images/Frame 14.png`}
              >
            </Cards>
          </Grid>
          <Grid item xs={8} sm={6} md={4} lg={2}>
            <Cards
              link={`/project/${projectId}/buyermap`}
              title={'Buyer Map'}
              text='Customer pain at different stages of purchase and consuming'
              imgPath={`${process.env.PUBLIC_URL}/images/Frame 6.png`}
              >
            </Cards>
          </Grid>
          <Grid item xs={8} sm={6} md={4} lg={2}>
            <Cards
              link={`/project/${projectId}/noncustomers`}
              title={'NonCustomers'}
              text={`For whom the competitors product is not suitable, but our product is suitable`}
              imgPath={`${process.env.PUBLIC_URL}/images/Frame 7.png`}
              >
            </Cards>
          </Grid>
          <Grid item xs={8} sm={6} md={4} lg={2}>
            <Cards
              link={`/project/${projectId}/errc`}
              title={'ERRC'}
              text={'Eliminate and Reduce costs, Raise and Create value'}
              imgPath={`${process.env.PUBLIC_URL}/images/Frame 16.png`}
              >
            </Cards>
          </Grid>
          <Grid item xs={8} sm={6} md={4} lg={2}>
            <Cards
              link={`/project/${projectId}/tobestrategymap`}
              title={'To-Be Strategy Canvas'}
              text={'Our competitive position'}
              imgPath={`${process.env.PUBLIC_URL}/images/Frame 8.png`}
              >
            </Cards>
          </Grid>
        </Grid>

        <h2>Marketing</h2>
        <Grid container spacing={7}>
          <Grid item xs={8} sm={6} md={4} lg={2}>
            <Cards
              link={`https://evilunion.com/calculator_ads/`}
              title={'Advertising Funnel'}
              imgPath={`${process.env.PUBLIC_URL}/images/Frame 9.png`}
              >
            </Cards>
          </Grid>
          <Grid item xs={8} sm={6} md={4} lg={2}>
            <Cards
              link={`https://www.awake-tools.com/ru/ca/`}
              title={'Correspondence'}
              imgPath={`${process.env.PUBLIC_URL}/images/Frame 15.png`}
              >
            </Cards>
          </Grid>
          <Grid item xs={8} sm={6} md={4} lg={2}>
            <Cards
              link={`https://evilunion.com/unit-economics/`}
              title={'Unit Economics Modeling with Cohort Analysis'}
              imgPath={`${process.env.PUBLIC_URL}/images/Frame 11.png`}
              >
            </Cards>
          </Grid>
        </Grid>

        <h2>Investment</h2>
        <Grid container spacing={7}>
          <Grid item xs={8} sm={6} md={4} lg={2}>
            <Cards
              link={`/project/${projectId}/developing`}
              title={'Investment Analysis'}
              imgPath={`${process.env.PUBLIC_URL}/images/Frame 12.png`}
              >
            </Cards>
          </Grid>
        </Grid>

      </>

    )
}

const mapStateToProps = state => state.project;

const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(
    mapStateToProps, mapDispatchToProps,
)(ProjectDetail)
